import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-client";
import type { PlanTask, StudyGoal } from "@examora/shared/plan/daily-plan";
import type { PhaseKey, StudyProfile } from "@examora/shared/plan/study-profile";
import type { Roadmap } from "./roadmap-view";
import type { SkillCode } from "@examora/shared/exam/cefr-scoring";

export type PlanResponse = {
  goal: StudyGoal | null;
  skillScores: Record<SkillCode, number | null>;
  tasks: PlanTask[];
  doneCount: number;
  weakestSkill: SkillCode;
  daysLeft: number | null;
  current: number | null;
  /** `current` is the questionnaire's level-check estimate (no mock result yet). */
  currentIsEstimate: boolean;
  target: number | null;
  phase: PhaseKey;
  /** Not one of the student's study days: only the words today. */
  restDay: boolean;
  studyProfile: StudyProfile | null;
  roadmap: Roadmap | null;
};

export const PLAN_KEY = ["plan"];

export function usePlan() {
  return useQuery({ queryKey: PLAN_KEY, queryFn: () => api.get<PlanResponse>("/api/v1/plan") });
}

/** Where each task's button takes the student. */
export function taskHref(task: PlanTask): string {
  if (task.kind === "mock") return task.scope === "full" ? "/exams?type=full" : `/exams?type=${task.skill}`;
  if (task.kind === "tutor") return "/tutor";
  return "/vocabulary";
}
